var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterAccountInfo.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as Yup from 'yup';
import { Footer, Form, Header, Input, InputPassword, LogoActionBar, Main, PasswordInputValidator, ScrollContainer, Spinner } from 'Components/utility';
import { PhoneInput } from 'Components/utility/PhoneInput';
import { REGISTER } from 'Reducers/register/types';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import { store } from 'Utilities/store';
const mapStateToProps = ({
  config: {
    validation
  }
}) => {
  return {
    validation,
    leadingTrailingSpacesIdentity: validation?.identity.find(identity => identity.data.key === 'leadingTrailingSpaces')
  };
};
const connector = connect(mapStateToProps);
const RegisterAccountInfo = ({
  back,
  values: currentValues,
  handleSubmitRegister,
  handleClickSignIn,
  loading,
  validation,
  leadingTrailingSpacesIdentity
}) => {
  const showPhoneInput = currentValues.country === 'US';
  const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
  const validationSchema = Yup.object().shape({
    email: Yup.string().email(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.errors.emailAddressValidEmail')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.errors.required')),
    phoneNumber: Yup.string().when('country', {
      is: country => country === 'US',
      then: Yup.string().required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).min(7, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).test('test-valid-phone', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'), value => parsePhoneNumberFromString(value ?? '', {
        extract: false
      })?.isValid() ?? false),
      otherwise: Yup.string().notRequired()
    }),
    password: leadingTrailingSpacesIdentity ? Yup.string().matches(new RegExp(leadingTrailingSpacesIdentity.data.regex), i18n.t(`Login.content.signInForm.formField.password.helpText.${leadingTrailingSpacesIdentity.data.key}`)) : Yup.string(),
    confirmPassword: Yup.string().oneOf([Yup.ref('password')], i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.confirmPasswordMustMatch')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.required'))
  });
  const onSubmit = useCallback(async (values, {
    setSubmitting
  }) => {
    try {
      setSubmitting(true);
      const register = {
        ...currentValues,
        ...values
      };
      store.dispatch({
        type: REGISTER,
        register
      });
      await handleSubmitRegister(register);
    } catch {
      log.error('Registration error');
    } finally {
      setSubmitting(false);
    }
  }, [currentValues, handleSubmitRegister]);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    isValid,
    errors,
    touched,
    values,
    isSubmitting
  } = useFormik({
    initialValues: {
      ...currentValues
    },
    validationSchema,
    onSubmit,
    validateOnBlur: true
  });
  const handleOnBack = useCallback(() => {
    back({
      ...values,
      password: '',
      confirmPassword: ''
    });
  }, [back, values]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "RegisterAccountInfo.action-go-back",
    titleTestID: "RegisterAccountInfo.actionTitle",
    title: i18n.t('CreateAccountAccountInfo.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "RegisterAccountInfo.title",
    subtitleTestID: "RegisterAccountInfo.subtitle",
    title: i18n.t('CreateAccountAccountInfo.title'),
    subtitle: i18n.t('Login.subtitle', {
      appName: i18n.t('Global.appNames.libreView')
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'),
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'),
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    testID: "email",
    value: values.email,
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    inputMode: "email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 11
    }
  }), showPhoneInput && /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.phoneNumber,
    isInvalid: errors.phoneNumber && touched.phoneNumber ? true : false,
    testID: "phoneNumber",
    value: values.phoneNumber,
    onChangeText: handleChange('phoneNumber'),
    onBlur: handleBlur('phoneNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(PasswordInputValidator, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'),
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    handleBlur: handleBlur('password'),
    onChangeText: handleChange('password'),
    password: values.password,
    onValidate: setMeetsPasswordRequirements,
    identities: validation?.identity,
    testID: "password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'),
    isInvalid: errors.confirmPassword && touched.confirmPassword ? true : false,
    errorMessage: errors.confirmPassword,
    testID: "confirmPassword",
    onBlur: handleBlur('confirmPassword'),
    onChangeText: handleChange('confirmPassword'),
    value: values.confirmPassword,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.links.next.label'),
    buttonTestID: "RegisterAccountInfo.nextButton",
    buttonLinkTitle: i18n.t('CreateAccountAccountInfo.content.footerSignIn.primaryText'),
    buttonLinkTitleTestID: "RegisterAccountInfo.alreadyHaveAccount",
    buttonLinkText: i18n.t('CreateAccountAccountInfo.content.footerSignIn.links.signIn.label'),
    buttonLinkTestID: "RegisterAccountInfo.signIn",
    onButtonSubmit: handleSubmit,
    onButtonLinkClick: handleClickSignIn,
    isButtonDisabled: !values.email || !values.password || !values.confirmPassword || !isValid || isSubmitting || !meetsPasswordRequirements,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 7
    }
  }));
};
export default connector(RegisterAccountInfo);